import { render, staticRenderFns } from "./BRD.vue?vue&type=template&id=54369e8f&scoped=true&"
import script from "./BRD.vue?vue&type=script&lang=js&"
export * from "./BRD.vue?vue&type=script&lang=js&"
import style0 from "./BRD.vue?vue&type=style&index=0&id=54369e8f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54369e8f",
  null
  
)

export default component.exports